import { useObjectUrl } from 'hooks/use-object-url';
import { RendererPropsData } from '../../types';
import { ImagePreviewerContainer } from './image-previewer.styled';

export const ImagePreviewer = ({ fileObj }: { fileObj: RendererPropsData }) => {
  const imageLink = useObjectUrl(fileObj.file);

  return (
    <ImagePreviewerContainer>
      <img src={imageLink ?? ''} />
    </ImagePreviewerContainer>
  );
};
